export function selectPage(page) {
  return {
    type: "@header/SET_SELECTED_PAGE",
    payload: { page },
  };
}
